import React, { useState } from 'react';
import { Table, Button, Alert, Tooltip, Space } from 'antd';
import { EditOutlined, MailOutlined } from '@ant-design/icons';
import EmailRecipientRuleModal from './modals/EmailRecipientRuleModal';
import SendTestEmailModal from './modals/SendTestEmailModal';
import { emailTypeLabel, emailTypeDescription } from './emailRecipientTypes';

const EmailList = ({ list, fallback }) => {
    if (!Array.isArray(list) || list.length === 0) return <span style={{ color: '#bfbfbf' }}>{fallback}</span>;
    return (
        <Tooltip title={list.join(', ')}>
            <span>{list.length === 1 ? list[0] : `${list[0]} +${list.length - 1}`}</span>
        </Tooltip>
    );
};

const EmailRecipientsPanel = ({ companyId, emailRules }) => {
    const { data, loading, error, refetch } = emailRules;
    const [modalOpen, setModalOpen] = useState(false);
    const [editingRule, setEditingRule] = useState(null);
    const [testOpen, setTestOpen] = useState(false);
    const [testingRule, setTestingRule] = useState(null);

    const columns = [
        {
            title: 'Email',
            dataIndex: 'email_type',
            key: 'email_type',
            render: (t) => (
                <div>
                    <div>{emailTypeLabel(t)}</div>
                    <div style={{ fontSize: 12, color: '#8c8c8c' }}>{emailTypeDescription(t)}</div>
                </div>
            ),
        },
        {
            title: 'To',
            key: 'to_override',
            render: (_, r) => <EmailList list={r.to_override} fallback="Default" />,
        },
        {
            title: 'CC',
            key: 'cc',
            render: (_, r) => <EmailList list={r.cc} fallback="—" />,
        },
        {
            title: 'BCC',
            key: 'bcc',
            render: (_, r) => <EmailList list={r.bcc} fallback="—" />,
        },
        {
            title: '',
            key: 'actions',
            width: 90,
            render: (_, r) => (
                <Space size="small">
                    <Tooltip title="Edit recipients">
                        <Button
                            type="text"
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => { setEditingRule(r); setModalOpen(true); }}
                        />
                    </Tooltip>
                    <Tooltip title="Send test email">
                        <Button
                            type="text"
                            size="small"
                            icon={<MailOutlined />}
                            onClick={() => { setTestingRule(r); setTestOpen(true); }}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    return (
        <div>
            {error && <Alert type="error" message={error} style={{ marginBottom: 12 }} />}

            <Table
                className="gh-dash-interview-table"
                columns={columns}
                dataSource={data}
                loading={loading}
                rowKey="email_type"
                size="small"
                pagination={false}
            />

            <EmailRecipientRuleModal
                open={modalOpen}
                rule={editingRule}
                companyId={companyId}
                onClose={() => { setModalOpen(false); setEditingRule(null); }}
                onSuccess={() => { setModalOpen(false); setEditingRule(null); refetch(); }}
            />

            <SendTestEmailModal
                open={testOpen}
                rule={testingRule}
                companyId={companyId}
                onClose={() => { setTestOpen(false); setTestingRule(null); }}
            />
        </div>
    );
};

export default EmailRecipientsPanel;
